export default __webpack_public_path__ + "static/media/maestro-chart-temp.9251c5d3.svg";